// src/components/admin/PrintFichasBatismo.js

import React from 'react';
import brasao from '../../assets/brasao_hd.png';

const OPCAO_LABEL = {
  batismo:       'Apenas Batismo',
  curso:         'Apenas Curso de Pais e Padrinhos',
  batismo_curso: 'Batismo + Curso',
};

const CSS = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Times New Roman', serif; color: #1a1a1a; background: white; }
  @page { size: A4 portrait; margin: 0; }

  .ficha-page {
    width: 210mm;
    min-height: 297mm;
    padding: 14mm 16mm;
    page-break-after: always;
    position: relative;
    background: white;
  }
  .ficha-page:last-child { page-break-after: avoid; }

  .ficha-header {
    display: flex;
    align-items: center;
    gap: 14px;
    border-bottom: 2.5px solid #1a3a6b;
    padding-bottom: 10px;
    margin-bottom: 14px;
  }
  .ficha-header img { width: 72px; height: 72px; object-fit: contain; }
  .ficha-header h1 { font-size: 13pt; color: #1a3a6b; margin: 0 0 2px; font-weight: bold; }
  .ficha-header p { font-size: 8.5pt; color: #555; margin: 1px 0; }
  .ficha-num { margin-left: auto; font-size: 8pt; color: #888; white-space: nowrap; }

  .ficha-title {
    text-align: center;
    font-size: 11.5pt;
    font-weight: bold;
    color: #1a3a6b;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 12px;
    padding: 5px 0;
    border-top: 1px solid #c9a030;
    border-bottom: 1px solid #c9a030;
  }
  .turma-badge {
    background: #c9a030;
    color: #1a1a1a;
    font-size: 8pt;
    font-weight: bold;
    padding: 2px 10px;
    border-radius: 3px;
    display: inline-block;
    margin-left: 10px;
    vertical-align: middle;
  }
  .tipo-badge {
    display: inline-block;
    background: #1a3a6b;
    color: white;
    font-size: 8pt;
    font-weight: bold;
    padding: 3px 12px;
    border-radius: 3px;
    margin-bottom: 10px;
    letter-spacing: 0.04em;
  }
  .section { margin-bottom: 11px; }
  .section-title {
    font-size: 8pt;
    font-weight: bold;
    color: #1a3a6b;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    border-bottom: 1px solid #1a3a6b;
    margin-bottom: 7px;
    padding-bottom: 2px;
  }
  .grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 4px 16px; }
  .grid3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 4px 12px; }
  .field { display: flex; flex-direction: column; margin-bottom: 5px; }
  .field label { font-size: 7pt; color: #777; text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 1px; }
  .field span { font-size: 9.5pt; font-weight: bold; border-bottom: 0.5px solid #ccc; padding-bottom: 2px; min-height: 15px; }

  table { width: 100%; border-collapse: collapse; margin-top: 5px; font-size: 9pt; }
  thead th { background: #1a3a6b; color: white; padding: 5px 6px; text-align: center; font-size: 8pt; }
  tbody td { border: 1px solid #aaa; padding: 6px; text-align: center; }
  tbody td:first-child { text-align: left; font-weight: bold; background: #f5f5f5; width: 24%; }
  tbody td:nth-child(2) { width: 16%; }
  .check { display: inline-block; width: 14px; height: 14px; border: 1.5px solid #555; border-radius: 2px; }

  .batismo-date { font-size: 11pt; color: #c9a030; font-weight: bold; }
  .obs-box { border: 0.5px solid #ccc; height: 38px; border-radius: 3px; margin-top: 4px; }
  .footer {
    position: absolute;
    bottom: 10mm;
    left: 16mm;
    right: 16mm;
    border-top: 0.5px solid #ccc;
    padding-top: 5px;
    display: flex;
    justify-content: space-between;
    font-size: 7pt;
    color: #999;
  }
`;

const FichaPage = ({ inscricao, turmas, numero, total }) => {
  const turma = turmas.find(t => t.id === inscricao.turmaId) || {};

  const reunioes = [
    { label: '1ª Reunião', data: turma.reuniao1 },
    { label: '2ª Reunião', data: turma.reuniao2 },
    { label: '3ª Reunião', data: turma.reuniao3 },
    { label: '4ª Reunião', data: turma.reuniao4 },
  ].filter(r => r.data);

  const fmt = (d) => {
    if (!d) return '—';
    let s = String(d).trim();
    if (s.includes('T')) s = s.split('T')[0];
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      const [y, m, day] = s.split('-');
      return `${day}/${m}/${y}`;
    }
    return s;
  };

  return (
    <div className="ficha-page">
      {/* Cabeçalho */}
      <div className="ficha-header">
        <img src={brasao} alt="Brasão" />
        <div>
          <h1>Paróquia Nossa Senhora da Conceição</h1>
          <p>Messejana – Fortaleza, CE &nbsp;|&nbsp; R. Joaquim Bezerra, 235</p>
          <p>📱 (85) 98134-6247 &nbsp;|&nbsp; www.paroquiademessejana.com.br</p>
        </div>
        <div className="ficha-num">Ficha {numero}/{total}</div>
      </div>

      {/* Título */}
      <div className="ficha-title">
        Ficha de Inscrição — Batismo
        <span className="turma-badge">Turma: {inscricao.turmaNome || '—'}</span>
      </div>

      {/* Tipo */}
      <div>
        <span className="tipo-badge">
          {OPCAO_LABEL[inscricao.opcao] || inscricao.opcao || '—'}
        </span>
      </div>

      {/* Dados da criança */}
      <div className="section">
        <div className="section-title">Dados da Criança</div>
        <div className="grid2">
          <div className="field" style={{ gridColumn: '1 / -1' }}>
            <label>Nome Completo</label>
            <span>{inscricao.nomeFilho || '—'}</span>
          </div>
          <div className="field">
            <label>Data de Nascimento</label>
            <span>{fmt(inscricao.dataNascimento)}</span>
          </div>
          <div className="field">
            <label>Telefone / WhatsApp</label>
            <span>{inscricao.telefone || '—'}</span>
          </div>
        </div>
      </div>

      {/* Responsáveis */}
      <div className="section">
        <div className="section-title">Responsáveis</div>
        <div className="grid2">
          <div className="field">
            <label>Nome do Pai</label>
            <span>{inscricao.nomePai || '—'}</span>
          </div>
          <div className="field">
            <label>Nome da Mãe</label>
            <span>{inscricao.nomeMae || '—'}</span>
          </div>
        </div>
      </div>

      {/* Padrinhos */}
      {(inscricao.nomePadrinho || inscricao.nomeMadrina) && (
        <div className="section">
          <div className="section-title">Padrinhos</div>
          <div className="grid2">
            <div className="field">
              <label>Padrinho</label>
              <span>{inscricao.nomePadrinho || '—'}</span>
            </div>
            <div className="field">
              <label>Madrinha</label>
              <span>{inscricao.nomeMadrina || '—'}</span>
            </div>
          </div>
        </div>
      )}

      {/* Quadro de reuniões */}
      {reunioes.length > 0 && (
        <div className="section">
          <div className="section-title">Controle de Presenças nas Reuniões</div>
          <table>
            <thead>
              <tr>
                <th>Reunião</th>
                <th>Data</th>
                <th>Pai / Responsável</th>
                <th>Mãe / Responsável</th>
                <th>Padrinho</th>
                <th>Madrinha</th>
              </tr>
            </thead>
            <tbody>
              {reunioes.map((r, i) => (
                <tr key={i}>
                  <td>{r.label}</td>
                  <td>{fmt(r.data)}</td>
                  <td><div className="check" /></td>
                  <td><div className="check" /></td>
                  <td><div className="check" /></td>
                  <td><div className="check" /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Data do Batismo */}
      {turma.dataBatismo && (
        <div className="section">
          <div className="section-title">Data do Batismo</div>
          <p className="batismo-date">{fmt(turma.dataBatismo)}</p>
        </div>
      )}

      {/* Observações */}
      <div className="section">
        <div className="section-title">Observações</div>
        <div className="obs-box" />
      </div>

      {/* Rodapé */}
      <div className="footer">
        <span>Paróquia N. Sra. da Conceição – Messejana</span>
        <span>Gerada em {new Date().toLocaleDateString('pt-BR')}</span>
      </div>
    </div>
  );
};

const PrintFichasBatismo = ({ inscricoes, turmas, onClose }) => {
  const pendentes = inscricoes.filter(s => s.status === 'Pendente');

  const handlePrint = () => {
    const printWindow = window.open('', '_blank', 'width=900,height=700');
    if (!printWindow) {
      alert('Pop-up bloqueado! Permita pop-ups para este site e tente novamente.');
      return;
    }

    // Serializar as fichas para HTML puro com imagem em base64
    const fichasEl = document.getElementById('fichas-print-content');
    const fichasHtml = fichasEl ? fichasEl.innerHTML : '';

    printWindow.document.write(`<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="UTF-8" />
  <title>Fichas de Batismo — ${pendentes.length} inscrições</title>
  <style>${CSS}</style>
</head>
<body>${fichasHtml}</body>
</html>`);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
    }, 1000);
  };

  return (
    <>
      {/* Overlay de preview */}
      <div style={{
        position: 'fixed', inset: 0, zIndex: 3000,
        background: 'rgba(10,20,40,0.92)',
        display: 'flex', flexDirection: 'column',
      }}>
        {/* Barra de controle */}
        <div style={{
          background: 'var(--navy-dark)', padding: '1rem 2rem',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          borderBottom: '2px solid var(--gold)',
          flexShrink: 0,
        }}>
          <div>
            <h3 style={{ color: 'var(--white)', margin: 0, fontSize: '1rem' }}>
              Fichas de Batismo — {pendentes.length} inscrição{pendentes.length !== 1 ? 'ões' : ''} pendente{pendentes.length !== 1 ? 's' : ''}
            </h3>
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.8rem', margin: 0 }}>
              Visualize as fichas antes de imprimir
            </p>
          </div>
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            <button onClick={onClose} className="btn btn-sm"
              style={{ background: 'rgba(255,255,255,0.1)', color: 'var(--white)', border: '1px solid rgba(255,255,255,0.2)' }}>
              ✕ Fechar
            </button>
            <button onClick={handlePrint} className="btn btn-primary btn-sm" disabled={pendentes.length === 0}>
              🖨️ Imprimir todas
            </button>
          </div>
        </div>

        {/* Preview scrollável */}
        <div style={{ overflowY: 'auto', padding: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.5rem', flex: 1 }}>
          {pendentes.length === 0 ? (
            <div style={{ color: 'rgba(255,255,255,0.5)', padding: '4rem', textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📋</div>
              <p>Nenhuma inscrição pendente para imprimir.</p>
            </div>
          ) : (
            pendentes.map((insc, i) => (
              <div key={insc.id || i} style={{
                background: 'white',
                boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
                transform: 'scale(0.72)',
                transformOrigin: 'top center',
                marginBottom: '-200px',
              }}>
                <FichaPage inscricao={insc} turmas={turmas} numero={i + 1} total={pendentes.length} />
              </div>
            ))
          )}
          <div style={{ height: '2rem' }} />
        </div>
      </div>

      {/* Fichas renderizadas fora da tela para capturar o HTML com imagens */}
      <div id="fichas-print-content" style={{ position: 'absolute', left: '-9999px', top: 0, background: 'white' }}>
        {pendentes.map((insc, i) => (
          <FichaPage key={insc.id || i} inscricao={insc} turmas={turmas} numero={i + 1} total={pendentes.length} />
        ))}
      </div>
    </>
  );
};

export default PrintFichasBatismo;
